import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  TimePicker
} from 'antd';

import { debounce } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Subtitle } from '../../../components';
import CustomDatePicker from '../../../components/CustomDatePicker';
import MapView from '../../../components/MapView';
import { useSiniestroContext } from '../../../context/siniestro-context';
import { useSolicitudContext } from '../../../context/solicitud-context';
import { getCoordenadasByDireccion } from '../../../utils';
import { instanceRef } from '../../../utils/axios';

const { TextArea } = Input;

const DatosAccidente = ({ ...props }) => {
  const { datosSiniestro } = useSiniestroContext();
  const { coordenadasMap, cambiarDatosMap } = useSolicitudContext();
  const [form] = Form.useForm();
  const [coordenadas, setCoordenadas] = useState();
  const [zoomMap, setZoomMap] = useState(8);
  const [marcadorMap, setMarcadorMap] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const history = useHistory();

  const onFinish = (values) => {
    if (coordenadasMap?.lat) {
      setCoordenadas(coordenadasMap);
    }
    const departamentoLabel = departamentos.find(
      (item) => item.id === values.departamento
    )?.descripcion;

    const distritoLabel = distritos.find((item) => item.id === values.distrito)
      ?.descripcion;

    const datosAccidente = {
      nombre_conductor: values.nombre_conductor,
      fecha_siniestro: values.fecha_siniestro,
      hora_siniestro: values.hora_siniestro,
      circunstancia_ocurrencia: values.circunstancia_ocurrencia,
      velocidad_circulacion: values.velocidad_circulacion,
      prefix: '+595',
      latitud: coordenadas?.lat,
      longitud: coordenadas?.lng,
      id_departamento: values.departamento,
      id_distrito: values.distrito,
      departamentoLabel,
      distritoLabel,
      domicilio: values.domicilio,
      terceros: props.datosIngresados.terceros
        ? props.datosIngresados.terceros
        : [{ nombres: '' }],
      tiene_terceros: props.datosIngresados.tiene_terceros,
      lesionados: props.datosIngresados.lesionados
        ? props.datosIngresados.lesionados
        : [{ nombres: '' }],
      tiene_lesionados: props.datosIngresados.tiene_lesionados,
      testigos: props.datosIngresados.testigos
        ? props.datosIngresados.testigos
        : [{ nombres: '' }],
      tiene_testigos: props.datosIngresados.tiene_testigos,
      autoridad: props.datosIngresados.autoridad,
      checkAutoridad: props.datosIngresados.checkAutoridad,
      danios_vehiculo: values.danios_vehiculo,
      danios_inmueble: values.danios_inmueble,
      lesiones: values.lesiones
    };
    props.handleSetDatosIngresados(datosAccidente);
    props.setStep(1);
  };
  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    if (coordenadasMap) {
      setCoordenadas(coordenadasMap);
      setMarcadorMap(true);
      setZoomMap(17);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordenadasMap]);

  useEffect(() => {
    if (props.datosIngresados.latitud) {
      setCoordenadas({
        lat: props.datosIngresados?.latitud,
        lng: props.datosIngresados?.longitud
      });
      setMarcadorMap(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const debounceDireccionChange = debounce(async () => {
    geocalizarSiniestroMap();
  }, 1000);

  const handleInputChange = (field, { target }) => {
    if (target) {
      form.setFieldsValue({
        [field]: target.value
      });
    }
  };

  const geocalizarSiniestroMap = async () => {
    const departamento = form.getFieldValue('departamento');
    const distrito = form.getFieldValue('distrito');
    const domicilio = form.getFieldValue('domicilio') || '';

    const departamentoDesc = departamento
      ? departamentos.find((item) => item.id === departamento)?.descripcion
      : '';

    const distritoDesc = distrito
      ? distritos.find((item) => item.id === distrito)?.descripcion
      : '';

    const direccionConcat = `${departamentoDesc}, ${distritoDesc}, ${domicilio}`;

    const coordenadasEncontrada = await getCoordenadasByDireccion(
      direccionConcat
    );

    if (domicilio.length > 0) {
      setZoomMap(17);
      setMarcadorMap(true);
    }

    if (coordenadasEncontrada) {
      setCoordenadas(coordenadasEncontrada);
    }
  };

  async function getDepartamentos() {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);
      const values = form.getFieldsValue();
      const { distrito } = values;
      const { departamento } = values;

      if (distrito) {
        await getDistritos(departamento);
      }
    } catch (error) {
      // error
    }
  }

  async function getDistritos(departamento) {
    try {
      if (departamento) {
        const response = await instanceRef.instance.get(
          `data/distritos?departamento=${departamento}`
        );
        const orderedDistritos = response.data.data.sort(function test(a, b) {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });
        setDistritos(orderedDistritos);
      }
    } catch (error) {
      // error
    }
  }

  const onClick = (nuevaCoordenada) => {
    cambiarDatosMap(nuevaCoordenada);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    getDepartamentos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  const roundToNearest5multiple = () => {
    const min = moment().minute();
    const dateTime = moment()
      .add(min > 55 && 1)
      .minutes(Math.round(min / 5) * 5)
      .format('HH:mm');
    return dateTime;
  };

  const disabledHours = () => {
    const hours = [];
    const currentHour = moment().hour();
    if (form.getFieldValue('fecha_siniestro').isSame(moment(), 'day')) {
      for (let i = currentHour + 1; i <= 24; i += 1) {
        hours.push(i);
      }
    }
    return hours;
  };

  const disabledMinutes = (selectedHour) => {
    const minutes = [];
    const currentMinute = moment().minute();
    if (
      selectedHour === moment().hour() &&
      form.getFieldValue('fecha_siniestro').isSame(moment(), 'day')
    ) {
      for (let i = currentMinute; i <= 60; i += 1) {
        minutes.push(i);
      }
    }
    return minutes;
  };

  return (
    <Card>
      <Form
        name="datosAccidente"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={{
          nombre_conductor: props.datosIngresados?.nombre_conductor,
          fecha_siniestro: props.datosIngresados?.fecha_siniestro
            ? props.datosIngresados?.fecha_siniestro
            : moment(),
          hora_siniestro: props.datosIngresados?.hora_siniestro
            ? props.datosIngresados?.hora_siniestro
            : moment(roundToNearest5multiple(), 'HH:mm'),
          circunstancia_ocurrencia:
            props.datosIngresados?.circunstancia_ocurrencia,
          danios_vehiculo: props.datosIngresados?.danios_vehiculo,
          danios_inmueble: props.datosIngresados?.danios_inmueble,
          velocidad_circulacion: props.datosIngresados?.velocidad_circulacion,
          departamento: props.datosIngresados?.id_departamento,
          distrito: props.datosIngresados?.id_distrito,
          domicilio: props.datosIngresados?.domicilio,
          lesiones: props.datosIngresados?.lesiones
        }}
      >
        <Subtitle>Datos del accidente</Subtitle>
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={12} md={12}>
            <Form.Item
              label="Fecha de Ocurrencia"
              name="fecha_siniestro"
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <CustomDatePicker
                style={{ width: '100%' }}
                disabledDate={(current) => {
                  return moment() <= current;
                }}
                placeholder="DD/MM/YYYY"
                format="DD/MM/YYYY"
              />
            </Form.Item>
          </Col>
          <Col xs={12} md={12}>
            <Form.Item
              label="Hora de Ocurrencia"
              name="hora_siniestro"
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <TimePicker
                style={{ width: '100%' }}
                format="HH:mm"
                disabledHours={disabledHours}
                disabledMinutes={disabledMinutes}
                inputReadOnly
                minuteStep={5}
              />
            </Form.Item>
          </Col>
          {(datosSiniestro?.poliza?.producto.codigo === 3 ||
            datosSiniestro?.poliza?.producto.codigo === 2 ||
            datosSiniestro?.poliza?.producto.codigo === 1 ||
            datosSiniestro?.poliza?.producto.codigo === 6) && (
            <>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Departamento"
                  name="departamento"
                  rules={[{ required: true, message: 'Campo requerido' }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    placeholder="Elegir departamento"
                    onChange={(value) => {
                      form.setFieldsValue({
                        departamento: value,
                        distrito: null
                      });
                      setDistritos([]);
                      getDistritos(value);
                      geocalizarSiniestroMap();
                      setZoomMap(10);
                    }}
                  >
                    {departamentos.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.descripcion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Ciudad"
                  name="distrito"
                  rules={[{ required: true, message: 'Campo requerido' }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    style={{ width: '100%' }}
                    placeholder="Elegir distrito"
                    onChange={() => {
                      geocalizarSiniestroMap();
                      setZoomMap(13);
                    }}
                  >
                    {distritos.map((item) => (
                      <Select.Option key={item.id} value={item.id}>
                        {item.descripcion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Dirección"
                  name="domicilio"
                  onChange={(e) => {
                    handleInputChange('domicilio', e);
                    debounceDireccionChange();
                  }}
                  rules={[{ required: true, message: 'Campo requerido' }]}
                >
                  <Input placeholder="Ingrese un valor" />
                </Form.Item>
              </Col>
              <Col xs={24} md={24} style={{ marginBottom: '10px' }}>
                <MapView
                  coordenadas={coordenadas}
                  zoom={zoomMap}
                  marker={marcadorMap}
                  onClick={onClick}
                />
              </Col>
            </>
          )}
          {datosSiniestro?.poliza?.producto.codigo === 1 && (
            <>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Nombre del Conductor"
                  name="nombre_conductor"
                  rules={[{ required: true, message: 'Requerido' }]}
                >
                  <Input placeholder="" />
                </Form.Item>
              </Col>
              <Col xs={12} md={12}>
                <Form.Item
                  label="Velocidad de Circulación (en Km/h)"
                  name="velocidad_circulacion"
                  rules={[{ required: true, message: 'Campo requerido' }]}
                >
                  <InputNumber min={0} max={300} style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            </>
          )}
          <Col xs={24} md={24}>
            <Form.Item
              label="Circunstancia de Ocurrencia"
              name="circunstancia_ocurrencia"
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <TextArea rows={4} placeholder="Descripción de la ocurrencia" />
            </Form.Item>
          </Col>
          {(datosSiniestro?.poliza?.producto.codigo === 2 ||
            datosSiniestro?.poliza?.producto.codigo === 3) && (
            <Col xs={24} md={24}>
              <Form.Item
                label="Descripción de Lesiones"
                name="lesiones"
                rules={[{ required: true, message: 'Requerido' }]}
              >
                <TextArea rows={4} placeholder="Descripción de las Lesiones" />
              </Form.Item>
            </Col>
          )}
          {(datosSiniestro?.poliza?.producto.codigo === 4 ||
            datosSiniestro?.poliza?.producto.codigo === 5) && (
            <Col xs={24} md={24}>
              <Form.Item
                label="Daños del Inmueble"
                name="danios_inmueble"
                rules={[{ required: true, message: 'Requerido' }]}
              >
                <TextArea rows={4} placeholder="Descripción de los daños" />
              </Form.Item>
            </Col>
          )}
          {(datosSiniestro?.poliza?.producto.codigo === 1 ||
            datosSiniestro?.poliza?.producto.codigo === 7) && (
            <Col xs={24} md={24}>
              <Form.Item
                label="Daños del Vehículo"
                name="danios_vehiculo"
                rules={[{ required: true, message: 'Requerido' }]}
              >
                <TextArea rows={4} placeholder="Descripción de los daños" />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Button
          style={{ margin: 10 }}
          onClick={() =>
            handleOpenUrl(`/denuncia-siniestro-landing/${datosSiniestro.token}`)
          }
        >
          Anterior
        </Button>
        <Button type="primary" htmlType="submit">
          Siguiente
        </Button>
      </Form>
    </Card>
  );
};

export default DatosAccidente;
